import { render, staticRenderFns } from "./mSuperIpt.vue?vue&type=template&id=13e0f9b5&scoped=true&"
import script from "./mSuperIpt.vue?vue&type=script&lang=js&"
export * from "./mSuperIpt.vue?vue&type=script&lang=js&"
import style0 from "./mSuperIpt.vue?vue&type=style&index=0&id=13e0f9b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0f9b5",
  null
  
)

export default component.exports